"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=require("@mui/material"),t=require("@mui/material/styles"),n=t.styled(o.Menu)`
  &&.MuiModal-root {
    z-index: 1305;
  }

  &&.MuiMenu-paper {
    z-index: 2001;
  }
`,r=t.styled(o.MenuItem)(({theme:e})=>({color:e.palette.grey[800],"&:hover":{backgroundColor:e.palette.primary[50]}}));exports.PhoneItem=r;exports.PhoneMenu=n;
